import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Self-heal stale code-split chunks. When a new build is deployed, a tab
// still running the old build can ask for chunk filenames that no longer
// exist -> ChunkLoadError (often surfacing as "Unexpected token '<'" when
// the server returns index.html in their place). Reload ONCE to pull the
// current build; a sessionStorage guard prevents an infinite reload loop.
function isChunkLoadError(message) {
  return /ChunkLoadError/i.test(message || '') ||
    /Loading chunk [\w-]+ failed/i.test(message || '') ||
    /Loading CSS chunk/i.test(message || '');
}

function recoverFromChunkError() {
  if (sessionStorage.getItem('chunk_reload') === '1') return; // already tried
  sessionStorage.setItem('chunk_reload', '1');
  window.location.reload();
}

// Clear the guard on a clean load so future stale-chunk events can recover.
window.addEventListener('load', () => {
  setTimeout(() => sessionStorage.removeItem('chunk_reload'), 5000);
});

window.addEventListener('error', (event) => {
  if (isChunkLoadError(event?.message) ||
      isChunkLoadError(event?.error?.message)) {
    recoverFromChunkError();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event?.reason;
  if (isChunkLoadError(reason?.message) || isChunkLoadError(String(reason))) {
    recoverFromChunkError();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
